export enum PayoutTime {
  FOUR_DAYS = '4DAYS',
  TWO_WEEKS = '2WEEKS',
  SIX_WEEKS = '6WEEKS',
  NOT_YET = 'NOTYET'
}

const payoutTimeAscending = [
  { label: 'In den nächsten 4 Tagen', value: PayoutTime.FOUR_DAYS },
  {
    label: 'In den nächsten 2 Wochen',
    value: PayoutTime.TWO_WEEKS
  },
  {
    label: 'In den nächsten 6 Wochen',
    value: PayoutTime.SIX_WEEKS
  },
  {
    label: 'Noch nicht festgelegt',
    value: PayoutTime.NOT_YET
  }
]

const payoutTimeDescending = [
  {
    label: 'Noch nicht festgelegt',
    value: PayoutTime.NOT_YET
  },
  {
    label: 'In den nächsten 6 Wochen',
    value: PayoutTime.SIX_WEEKS
  },
  {
    label: 'In den nächsten 2 Wochen',
    value: PayoutTime.TWO_WEEKS
  },
  { label: 'In den nächsten 4 Tagen', value: PayoutTime.FOUR_DAYS }
]

export { payoutTimeAscending, payoutTimeDescending }
